<template>
	<div id="page-nav" class="pb-6">

		<v-container class="landing-description container-wrapper hidden-sm-and-down">
			<v-row>
				<v-col cols="12" md="6">
					<router-link to="/" class="pa-0">
						<v-img contain src="@/assets/app/logo/geoportal.png" aspect-ratio="2.5" width=150>
						</v-img>
					</router-link>
				</v-col>

				<v-col cols="12" md="6" class="atlas-nav-title text-md-right text-center pt-6">

					<router-link to="/">
						pradžia
					</router-link>

					<router-link to="/gallery">
						galerija
					</router-link>

					<router-link v-if="isAdmin" to="/admin">
						administravimas
					</router-link>

					<router-link v-if="isLoggedIn" to="/my-content">
						mano turinys
					</router-link>
					<router-link v-else to="/my-content">
						prisijungti
					</router-link>

					<a href="https://www.geoportal.lt/geoportal/pagalba">
						pagalba
					</a>

					<LogoutButton :dark="true" />

				</v-col>

			</v-row>

		</v-container>

		<div class="navigation-main height-100 pt-3 hidden-md-and-up">

			<v-app-bar elevation=0 color="rgba(255, 255, 255, 0.0)">

				<v-row justify="center" class="px-5">
					<v-col cols="6" md="2" sm="2">
						<v-img contain src="@/assets/app/logo/geoportal.png" aspect-ratio="2.5" width=150>
						</v-img>
					</v-col>

					<v-col cols="6" md="6" sm="10" class="font-weight-medium d-flex align-center justify-end">

						<v-app-bar-nav-icon @click="drawer = true" color="#fff"></v-app-bar-nav-icon>

					</v-col>

				</v-row>

			</v-app-bar>

			<v-navigation-drawer v-model="drawer" absolute temporary>

				<v-list nav dense>
					<v-list-item-group active-class="">

						<v-list-item :to="{ path: '/', hash: '#main-description' }" router>
							<v-list-item-title>apie</v-list-item-title>
						</v-list-item>

						<v-list-item :to="{ path: '/gallery' }" router>
							<v-list-item-title>galerija</v-list-item-title>
						</v-list-item>

						<v-list-item v-if="isAdmin" :to="{ path: '/admin' }" router>
							<v-list-item-title>administravimas</v-list-item-title>
						</v-list-item>

						<v-list-item :to="{ path: '/my-content' }" router>
							<v-list-item-title>
								{{ isLoggedIn ? 'mano turinys' : 'prisijungti' }}
							</v-list-item-title>
						</v-list-item>	

						<v-list-item href="https://www.geoportal.lt/geoportal/pagalba" tag="a">
							<v-list-item-title>pagalba</v-list-item-title>
						</v-list-item>

					</v-list-item-group>
				</v-list>
			</v-navigation-drawer>

		</div>

	</div>
</template>

<script>

import CommonHelper from "../helpers/CommonHelper";
import LogoutButton from "../LogoutButton";

export default {
	props: {
		title: String,
		isAtlas: Object
	},
	data: function () {
		var data = {
			rootTitle: "Geoportal.lt atlasai",
			isAdmin: CommonHelper.isUserAdmin(),
			isLoggedIn: CommonHelper.isUserSigned(),
			drawer: false
		};
		return data;
	},
	components: {
		LogoutButton
	},
	methods: {
		getAtlasActionTitle: function (type) {
			var title = type;
			if (type == "edit") {
				title = "Redagavimas";
			} else if (type == "view") {
				title = "Peržiūra";
			}
			return title;
		}
	}
};
</script>

<style scoped>
.atlas-nav-title a {
	color: rgb(255, 255, 255) !important;
}

.atlas-nav-title a:hover {
	color: rgb(255, 255, 225, 0.7) !important;
}
</style>